import React from 'react';
import { useGender } from 'services/assist-api/entities/gender/genders';

const GenderDisplay = React.memo(({ genderId }: { genderId: number }) => {
  const gender = useGender(genderId).data?.json;
  return <>{gender?.name}</>;
});

export default GenderDisplay;
